import axiosAuth from '../../axios/auth';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
import { routes } from '../../router/routes';

// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {

    transactionsCached : JSON.parse( localStorage.getItem( 'transactionsCached' ) ) || null,
    allTransactions    : [],
    currentTransaction : JSON.parse( localStorage.getItem( 'currentTransaction' ) ) || null,
    currentPage        : 1,
    pageLimit          : 10,
    totalTransactions  : JSON.parse( localStorage.getItem( 'totalTransactions' ) ) || 0
};

const mutations = {

    setTransactions( state, data ){

        // console.log( 'data coming through..', data );
        if( data.body.length > 0 ){

            let dbPromise = idb.open( 'quickOrdersDB', data.idbVersion );
            dbPromise.then( db => {

                let txCategories = db.transaction( 'pastTransactions', 'readwrite' );
                txCategories.objectStore( 'pastTransactions' ).clear();
                state.allTransactions = [];
                data.body.forEach( value => {

                    // console.log( 'transaction data: ', value );
                    txCategories.objectStore( 'pastTransactions' ).put( value );
                    state.allTransactions.push( value );
                });
            });
        }

        state.totalTransactions = data.totalTransactions;
        localStorage.setItem( 'totalTransactions', data.totalTransactions );

        const timestamp = parseInt( new Date().getTime() );
        state.transactionsCached = timestamp;
        localStorage.setItem( 'transactionsCached', timestamp );
    },
    clearState( state ){

        state.allTransactions = [];

        state.transactionsCached = null;
        localStorage.removeItem( 'transactionsCached' );

        state.currentTransaction = null;
        localStorage.removeItem( 'currentTransaction' );

        state.currentPage = 1;
        state.pageLimit   = 10;

        state.totalTransactions = 0;
        localStorage.removeItem( 'totalTransactions' );
    },
    pageTransactions( state, direction ){

        state.currentPage += direction;
    }
};

const actions = {

    getTransactions( { commit, getters, rootGetters }, paging = false ){

        if( paging || getters.transactionsCached == null || parseInt( getters.transactionsCached ) + parseInt( 5 * 60 * 1000 ) < parseInt( new Date().getTime() ) ){ // only load if not cached recently

            axiosAuth({

                method: 'post',
                url: '/usersTransactions',
                data: qs.stringify( {

                    merchantId  : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                    currentPage : getters.currentPage,
                    count       : getters.pageLimit
                } ),
                headers: {

                    'Content-Type' : 'application/x-www-form-urlencoded',
                    'AuthType'     : 'JWT',
                    'ApiKey'       : process.env.VUE_APP_API_KEY,
                    'Token'        : localStorage.getItem( 'token' ) || null
                }
            }).then( res => {

                // console.log( 'result: ', res.data );
                if( res.data.responseCode == 100 ){

                    // run a diff
                    if( getters.allTransactions.length > 0 ){ // we have some currently loaded

                        res.data.body.forEach( ( tran, key ) => {

                            for( let i = 0; i < getters.allTransactions.length; i++ ){

                                if( tran.Transaction.transactionId == getters.allTransactions[ i ].Transaction.transactionId ){

                                    res.data.body[ key ].alreadyExists = true;
                                    break;
                                }
                            }
                        });

                        const newTransactions = res.data.body.filter( tran => !tran.alreadyExists );
                        const payload = {

                            body              : newTransactions, // only push the new ones not previously seen
                            idbVersion        : rootGetters[ 'idbVersion' ],
                            totalTransactions : res.data.total
                        };
                        commit( 'setTransactions', payload );
                    } else {

                        const payload = {

                            body              : res.data.body,
                            idbVersion        : rootGetters[ 'idbVersion' ],
                            totalTransactions : res.data.total
                        };
                        commit( 'setTransactions', payload );
                    }
                } else {

                    console.log( 'server error' );
                }
            }).catch( err => {

                console.error( 'error! ', err );
            });
        }
    },
    clearState( { commit } ){

        commit( 'clearState' );
    },
    pageTransactions( { commit, dispatch, getters }, direction ){

        if( direction == -1 && getters.currentPage <= 1 ){

            // do nothing
        } else if( direction == 1 && getters.currentPage >= getters.totalPages ){

            // do nothing
        } else {

            commit( 'pageTransactions', direction );
            dispatch( 'getTransactions', true );
        }
    }
};

const getters = {

    transactionsCached : state => state.transactionsCached,
    allTransactions    : state => state.allTransactions,
    currentPage        : state => state.currentPage,
    pageLimit          : state => state.pageLimit,
    totalTransactions  : state => state.totalTransactions,
    totalPages( state ){

        return Math.ceil( state.totalTransactions / state.pageLimit );
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};